import axios from "axios";
import { serviceUrl } from "../../config";
import {
  checkSessionIsActive,
  getSessionData,
} from "../utilfunctions/utilFunctions";
import { resetSession } from "./sessions";

const BACKEND_URL = serviceUrl;

export const getUsers = async () => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "ListCustomer",
      dat: {
        location: "",
        franchiseeid: "119",
        firstname: "",
        lastname: "",
        phoneno: "",
        cityname: "",
        stateid: "",
        countryid: "",
        other1: "",
        other2: "",
        other3: "",
        usertype: "0",
        startuserid: "0",
        limit: "0",
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getUserDetails = async (userid) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "GetCustomerWithID",
      dat: {
        location: "",
        userid: userid,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }

    // console.log(response)

    return response.data.payload.body;
  } catch (error) {
    console.log(error);
  }
};

export const getUserDetailsNew = async (userid) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "GetCustomerWithIDNew",
      dat: {
        location: "",
        userid: userid,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }

    // console.log(response)

    return response.data.payload.body;
  } catch (error) {
    console.log(error);
  }
};

export const GetCustomerData = async (userid) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "GetCustomerData",
      dat: {
        location: "",
        userid: userid,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }

    // console.log(response)
    // console.log(response.data.data.body)

    return response.data.data.body;
  } catch (error) {
    console.log(error);
  }
};

export const editUserDetails = async (
  userid,
  list,
  email,
  s1user,
  name,
  screenresult,
) => {
  try {
    const sessionData = getSessionData();
    // console.log(userid, list);
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "EditUserFieldsWithoutPIN2",
      dat: {
        userid: userid,
        list: list,
        email: email,
        s1user: s1user,
        firstName: name,
        screenresult: screenresult,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const CreateUser = async (username, password, email, phoneno, dob) => {
  try {
    const sessionData = getSessionData();
    // console.log(userid, list);
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "EditUserFieldsWithoutPIN",
      dat: {
        username: email,
        password: password,
        email: email,
        phoneno: phoneno,
        dob: dob,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const setUserPassword = async (password, email) => {
  try {
    const sessionData = getSessionData();
    // console.log(userid, list);
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "setUserPassword",
      dat: {
        username: email,
        password: password,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const setFirstLoginPassword = async (password, email, pin) => {
  try {
    const data = JSON.stringify({
      svc: "forgot_password",
      pid: "setNewUserPassword",
      dat: {
        username: email,
        password: password,
        pin: pin,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const setFirstLoginPIN = async (username, pin, oldpin, userid) => {
  try {
    const data = JSON.stringify({
      svc: "forgot_password",
      pid: "changePIN",
      dat: {
        username: username,
        newPIN: pin,
        oldPIN: oldpin,
        userID: userid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const PictureNew = async (userid, imagedata) => {
  try {
    const sessionData = getSessionData();
    // console.log(userid, list);
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "PictureNew",
      dat: {
        userid: userid,
        imagedata: imagedata,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getBalances = async (userid, imagedata) => {
  try {
    const sessionData = getSessionData();
    // console.log(userid, list);
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "GetBalances",
      dat: {
        userid: userid,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    return response.data.payload;
  } catch (error) {
    console.log(error);
  }
};

export const getCardholdermessages = async (customerinput, isAdmin) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "getCardholdermessages",
      dat: {
        customerinput: customerinput,
        isAdmin: isAdmin,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getCardholderemessages = async (customerinput) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "getCardholderemessages",
      dat: {
        customerinput: customerinput,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getCardHolderEmailBody = async (customeremailid, isAdmin) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "getCardHolderEmailBody",
      dat: {
        customeremailid: customeremailid,
        isAdmin: isAdmin,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    return response;
  } catch (error) {
    console.log(error);
  }
};

// export const NewUser = async (
//   email,
//   firstName,
//   lastName,
//   country,
//   city,
//   phoneno,
//   address,
//   zip,
//   dob,
//   idNumber
// ) => {
//       try {
//     const data = JSON.stringify({
//       svc: "crm_users",
//       pid: "register",
//       dat: {
//         email: email,
//         firstName: firstName,
//         lastName: lastName,
//         country: country,
//         city: city,
//         phoneno: phoneno,
//         address: address,
//         zip: zip,
//         dob: dob,
//         idNumber: idNumber,
//       },
//     });

//     const config = {
//       method: "post",
//       url: BACKEND_URL,
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: data,
//     };

//         const response = await axios(config);
//     return response;
//   } catch (error) {
//     console.log(error);
//   }
// };

export const NewUser = async (userData, agentID, isMerchant) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "register2",
      dat: {
        ...userData,
        agentID: agentID,
        ismerchant: isMerchant,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const NewPortaluser = async (userData) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      // pid: "CreateSubUser",
      pid: "registerPortalUser",
      dat: {
        ...userData,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const MerchantPiAdd = async (userid, piid, gatewayid) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "MerchantPiAdd",
      dat: {
        userid: userid,
        piid: piid,
        gatewayid: gatewayid,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const sendSMS = async (phoneno, smstext, customerid, country) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "sendSMS",
      dat: {
        phoneno: phoneno,
        smstext: smstext,
        customerid: customerid,
        country: country,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getDailyLimit = async (userid) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "policy",
      pid: "p05",
      dat: {
        userid: userid,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const forgotPassword = async (username) => {
  try {
    const data = JSON.stringify({
      svc: "forgot_password",
      pid: "setUserPassword",
      dat: {
        username: username,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const sendSMSMFA = async (phone, customerId, country) => {
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "SendSMSMFA",
      dat: {
        phone: phone,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const sendEmailMFA = async (useremail, firstName, lastName) => {
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "SendMFAEmail",
      dat: {
        useremail: useremail,
        userfname: firstName,
        userlname: lastName,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const CalculateRiskScore = async (id, userid, langID) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "CalculateRiskScore",
      dat: {
        id: id,
        userid: userid,
        langID: langID,
        ...sessionData,
      },
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const GetPurposeOfAccount = async () => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "GetPurposeOfAccount",
      dat: {},
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const CloseAccount = async (kycuser, merchantid, PIN) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "closeuseraccount",
      dat: {
        kycuser: kycuser,
        merchantid: merchantid,
        PIN: PIN,
        ...sessionData,
      },
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const ReverseTransaction = async (
  referenceID,
  transType,
  transID,
  reason,
  pin,
  agentID,
) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "transactions",
      pid: "reversefeetransaction",
      dat: {
        transtype: transType,
        refid: referenceID,
        transid: transID,
        reason: reason,
        pin: pin,
        agentID: agentID,
        ...sessionData,
      },
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getCRMUsers = async () => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "getUserRoles",
      dat: {
        location: "",
        franchiseeid: "113",
        firstname: "",
        lastname: "",
        phoneno: "",
        cityname: "",
        stateid: "",
        countryid: "",
        other1: "",
        other2: "",
        other3: "",
        usertype: "0",
        startuserid: "0",
        limit: "0",
        ...sessionData,
      },
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const setFeeExempt = async (
  usersubaccount,
  vuser,
  feeexempted,
  purposefor,
) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "updatepidetails",
      dat: {
        usersubaccount: usersubaccount,
        vuser: vuser,
        feeexempted: feeexempted,
        purposefor: purposefor,
        ...sessionData,
      },
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getFeeExempt = async (usersubaccount, usersubaccountid) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "GetPIExternalInfo4",
      dat: {
        usersubaccount: usersubaccount,
        usersubaccountid: usersubaccountid,
        ...sessionData,
      },
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const ReverseVoucher = async (
  userid,
  pin,
  transferID,
  transactionID,
  agentuserid,
) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "voucher_transaction",
      pid: "CancelVoucherAgent",
      dat: {
        userid: userid,
        pin: pin,
        transferID: transferID,
        transactionID: transactionID,
        agentuserid: agentuserid,
        ...sessionData,
      },
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getPasswordCode = async (userid) => {
  try {
    const data = JSON.stringify({
      svc: "forgot_password",
      pid: "forgotpassword",
      dat: {
        forgotpassword: userid,
      },
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getPasswordCodeMobile = async (userid) => {
  try {
    const data = JSON.stringify({
      svc: "forgot_password",
      pid: "forgotpasswordmobile",
      dat: {
        forgotpassword: userid,
      },
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const setNewPassword = async (userid, token, password, userName) => {
  try {
    const data = JSON.stringify({
      svc: "forgot_password",
      pid: "setnewpwd2",
      dat: {
        userid: userid,
        confirmcode: token,
        pass1: password,
        thisemailinput: userName,
      },
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const AddFeeExempt = async (userData, agentID, userid) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "AddAutoAccounts_sync1",
      dat: {
        ...userData,
        userid: userid,
        agentID: agentID,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getCustomerTypes = async (queryid) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "RunQuery2",
      dat: {
        queryid: queryid,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getCustomerSubTypes = async (queryid, selectedCustomerType) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "RunQuery2",
      dat: {
        queryid: queryid,
        param: selectedCustomerType,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const updateUserProfileStatus = async (userId, list) => {
  try {
    const sessionData = getSessionData();
    // console.log(userid, list);
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "EditUserFieldsWithoutPIN",
      dat: {
        userid: userId,
        list: list,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const createUserTransactionsHoldingAccounts = async (
  userid,
  accountType,
  agentID,
  email,
  cardNo,
  purposeofaccount,
  feeexempt,
) => {
  try {
    const sessionData = getSessionData();
    // console.log(userid, list);
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "AddAutoAccounts_sync1",
      dat: {
        userid,
        accountType, // Transactions or Holding
        agentID,
        email,
        cardNo,
        purposeofaccount,
        feeexempt,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
  // AddAutoAccounts_sync1
};

export const getModulePermissions = async (userid, moduleLabel) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "getModulePermissions",
      dat: {
        userid: userid,
        label: moduleLabel,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const userUpdateTelephoneVerification = async (userid) => {
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "UserUpdateTelephoneVerification",
      dat: {
        location: "",
        userid: userid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const userAgentNotesAdd = async (userid, createdby, notes) => {
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "UserAgentNotesAdd",
      dat: {
        location: "",
        userid: userid,
        createdby: createdby,
        notes: notes,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const userAgentNotesUpdate = async (
  userid,
  createdby,
  notes,
  noteid,
) => {
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "UserAgentNotesUpdate",
      dat: {
        location: "",
        userid: userid,
        createdby: createdby,
        notes: notes,
        noteid: noteid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const userAgentNotesDelete = async (userid, noteid) => {
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "UserAgentNotesDelete",
      dat: {
        location: "",
        userid: userid,
        noteid: noteid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getUserSelfie = async (userid) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "getUserSelfie",
      dat: {
        location: "",
        userid: userid,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }

    // console.log(response)

    return response.data.payload.body;
  } catch (error) {
    console.log(error);
  }
};

export const getUserSidebarPermissions = async (userid) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "getUserSidebarPermissions",
      dat: {
        userid: userid,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const deviceTokenDeactivate = async (userid, deviceid) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "deviceTokenDeactivate2",
      dat: {
        userid: userid,
        id: deviceid,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const OFACCheck3 = async (userid, runby) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "OFACCheck4",
      dat: {
        userid: userid,
        runby: runby,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getGlobalPhoto = async (location = "", userids) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "GetGlobalPhoto",
      dat: {
        location: location,
        userids: userids,
        ...sessionData,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return;
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const createPayrollAdminMerchant = async (userId, companyName) => {
  try {
    const sessionData = getSessionData();

    const payload = {
      svc: "crm_users",
      pid: "NewMerchant", // ← new backend function name
      dat: {
        userId: userId,
        companyName: companyName.trim(),
        location: "", // you can pass real location if needed later
        ...sessionData,
      },
    };

    const data = JSON.stringify(payload);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Error creating payroll admin merchant profile:", error);
    throw error;
  }
};

export const updatePayrollAdminMerchantCompany = async (
  userId,
  companyName,
) => {
  try {
    const sessionData = getSessionData();

    const payload = {
      svc: "crm_users",
      pid: "UpdateMerchantProfile",
      dat: {
        userId: userId,
        companyName: companyName.trim(),
        location: "",
        ...sessionData,
      },
    };

    const data = JSON.stringify(payload);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Error updating payroll admin merchant company name:", error);
    throw error;
  }
  
};

export const ContactDelete = async (userId, id, contactuserid) => {
    try {
      const sessionData = getSessionData();

      const payload = {
        svc: "crm_users",
        pid: "ContactDelete",
        dat: {
          location: "",
          userid: userId,
          id: id,
          contactuserid: contactuserid,
        },
      };

      const data = JSON.stringify(payload);

      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      const response = await axios(config);

      return response.data;
    } catch (error) {
      console.error(
        "Error deleting:",
        error,
      );
      throw error;
    }
}
